import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable()
export class DynamicFormEventService {
  public readonly submit$: Subject<void> = new Subject<void>();
}
